import React from "react";
import { Upload } from "antd";
import styled from "styled-components";
import { Typography } from "../core";

const StyledUpload = styled(Upload)`
  display: flex;
  justify-content: center;
  /* display: flex;
  justify-content: center;
  .ant-upload.ant-upload-select-picture-card {
    background: none;
    border: 5px solid #233b67;
    
  } */
  /* .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0px;
  } */

  .ant-upload.ant-upload-select-picture-card {
    width: auto !important;
  }
`;
const UploadCompo = ({ children, className, ...props }) => {
  return (
    <>
      <Typography as="h4" color="#233b67" weight="bold" align="center">
        Upload Photo
      </Typography>
      <StyledUpload className={className} {...props}>
        {children}
      </StyledUpload>
    </>
  );
};

export default UploadCompo;
